import { createSelector } from 'reselect'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { getByIdExerciseSelector } from '@gymaholic/packages'

export const getNameByIdExerciseSelector = (exerciseId) => createSelector(
  getByIdExerciseSelector(exerciseId),
  (exercise) => {
    return getValueReduxUtil(exercise, 'name')
  }
)
